export default __webpack_public_path__ + "static/media/rod.4e5cb0ca.jpg";